

/** 短信code场景值 */
export enum ECodeScene {
  /** 注册 */
  REG = 'STORE_REG',
  /** 忘记密码 */
  FORGOT = 'STORE_FORGOT'
}